"use client"

import { useEffect } from "react"

export function PendaftarSw() {
  useEffect(() => {
    if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) return
    const daftar = () => navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => undefined)
    if (document.readyState === "complete") daftar()
    else window.addEventListener("load", daftar, { once: true })
    return () => window.removeEventListener("load", daftar)
  }, [])

  return null
}
